export const Types = {
  NOTIFY_RESET: 'notify/reset',
  NOTIFY_SUCCESS: 'notify/success',
  NOTIFY_ERROR: 'notify/error'
};

export default {};